<script setup lang="ts">
import type { WhatIsRelation } from "~/types/article"

defineProps({
  note: {
    type: Object as PropType<WhatIsRelation>,
    required: true,
  },
})
</script>

<template>
  <USidenote :note="note" title-class="text-[--theme-darker]">
    <template #content>
      <URichText
        class="!text-mobile-sidenote-p1 lg:!text-desktop-sidenote-p1 !font-national2"
        :html="note.resource.explanation"
      />
    </template>
  </USidenote>
</template>
